import { gql } from '@apollo/client';

export const ALL_INTERFACE_TYPES = gql`
  query AllInterfaceTypes {
    interfaceTypes: getInterfaceTypes {
      id
      name
    }
  }
`;
